import { ReactElement, useCallback } from 'react';

import { TherapeuticGroupSimple } from '@dreryk/egabinet-group-session-frontend-api';

import { Table } from '@dreryk/react-components';

import {
   useGroupSessionsTableColumnConfiguration,
   useGroupSessionsTableLazyLoadedDataConfigurationByCqrsQuery,
} from './GroupSessionsTable.hooks';
import { GroupSessionsEmptyStatePlaceholder } from './GroupSessionsEmptyStatePlaceholder';

const PAGE_SIZE = 50;

export const GroupSessionsTable = (): ReactElement => {
   const keyExtractor = useCallback(({ id }) => {
      return id.asNumber();
   }, []);

   return (
      <Table<TherapeuticGroupSimple>
         testId={'groupSessions'}
         columns={useGroupSessionsTableColumnConfiguration()}
         dataConfiguration={useGroupSessionsTableLazyLoadedDataConfigurationByCqrsQuery()}
         keyExtractor={keyExtractor}
         pageSize={PAGE_SIZE}
         placeholder={<GroupSessionsEmptyStatePlaceholder />}
      />
   );
};
